import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const StyledWrapper = styled.div`
    width: 100%;
    min-height: 100px;
`;

export const TrafficShareFooter = styled(FlexRow)`
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    padding: 8px 16px;
    justify-content: end;
`;

export const TrafficShareWrapper = styled(FlexColumn)`
    justify-content: space-between;
    width: 100%;
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 6px;
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
`;
